import React from 'react';
import PropTypes from 'prop-types';
import {LottieLXC} from './LottieLXC';

/**
 * Animator
 *  - Wrapper for react-lottie-lxc
 */
export function Animator(props) {
  const defaultOptions = {
    loop: false,
    autoplay: false,
    animationData: props.animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <LottieLXC
      options={defaultOptions}
      limits={props.limits}
      current={props.current}
      width={props.width}
      height={props.height}
    />
  );
}

Animator.propTypes = {
  /**
   * Lottie animation file
   */
  animationData: PropTypes.object,
  /**
   * Limit values from the Slider [ min, max ]
   */
  limits: PropTypes.arrayOf(PropTypes.number),
  /**
   * Current value for slider
   */
  current: PropTypes.number,
  /**
   * Width for canvas
   */
  width: PropTypes.string,
  /**
   * Height for canvas
   */
  height: PropTypes.string,
};

Animator.defaultProps = {};
